var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',{attrs:{"maxWidth":_vm.maxWidth,"arrowPos":_vm.arrowPos}},[_c('div',{staticClass:"tooltip"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }